<template>
  <div>
    <b-tooltip position="is-left" :label="$t('question.AllFolding')">
    <div v-if="!AllFolding.length" @click="AllFoldingFunction('open')">
      <img
        src="@/assets/img/icons/fold-icon.png"
        class="icon"
        alt="icon-fold"
      />
    </div>
    <div v-else @click="AllFoldingFunction('close')">
      <img
        src="@/assets/img/icons/fold-icon.png"
        style="transform: rotate(180deg);"
        class="icon"
        alt="icon-fold"
      />
    </div>
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ButtonAllFolding',
  computed: {
    ...mapGetters(['AllFolding'])
  },
  methods: {
    AllFoldingFunction (entry) {
      if (entry === 'open') {
        this.$store.commit(
          'UPDATE_ALL_FOLDING',
          this.$store.state.question.sections.length
            ? {type: 'sections', data: this.$store.state.question.sections}
            : {type: 'questions', data: this.$store.state.question.questions}
        )
      } else {
        this.$store.commit('UPDATE_ALL_FOLDING', {type: undefined, data: []})
      }
    }
  }
}
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  margin-top: 2px;
  margin-left: 10px;
  vertical-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/ButtonAllFolding.vue